module.exports = __webpack_public_path__ + "static/mona-cf615358c7a269231bf3b8397428e32c.webp";